import clsx from 'clsx'
import { unsafeCSS } from 'lit'
import { html } from 'lit/static-html.js'

import { DdsElement } from '@/internal/dds-hu-element'

import styles from './timeline-item.scss?inline'

/**
 * `dap-ds-timeline-item`
 * @summary A timeline is a graphical representation of a series of events.
 * @element dap-ds-timeline-item
 * @title - Timeline item
 * @group timeline
 *
 * @slot - The default slot for the item content.
 *
 * @csspart base - The main timeline item container.
 * @csspart connector - The connector element between two timeline items.
 * @csspart content - The content of the timeline item.
 *
 * @cssproperty --dds-timeline-position - Position of the timeline dot (default: 28px)
 * @cssproperty --dds-timeline-connector-width - Width of the timeline connector line (default: 1px)
 * @cssproperty --dds-timeline-connector-left-position - Left position of the timeline connector (default: 5.5px)
 * @cssproperty --dds-timeline-dot-size - Size of the timeline dot (default: var(--dds-spacing-300))
 * @cssproperty --dds-timeline-item-margin-bottom - Bottom margin of timeline items (default: var(--dds-spacing-200))
 * @cssproperty --dds-timeline-item-padding-left - Left padding of timeline items (default: var(--dds-spacing-400))
 */
export default class DapDSTimelineItem extends DdsElement {
  static tagName = 'dap-ds-timeline-item'

  static readonly styles = unsafeCSS(styles)

  render() {
    return html`
      <div
        part="base"
        class=${clsx('timeline-item', {
          'timeline-item--first': this.hasAttribute('first'),
          'timeline-item--last': this.hasAttribute('last'),
          'timeline-item--middle': this.hasAttribute('middle'),
        })}>
        <div part="connector" class="timeline-connector"></div>
        <div part="content" class="timeline-content">
          <slot></slot>
        </div>
      </div>
    `
  }
}
